import React from "react";
//#region types
import { InputSuggestionsExtraProps, FormFieldProps } from "models/propTypes/genericFormProps";
import { SelectionItem, SelectionResponse } from "models/utilTypes/selectionTypes";
//#endregion
//#region components
import InputSuggestions from "../baseFields/inputSuggestions";
import { useFormikContext } from "formik";
//#endregion
import { LocalizationHelperInstance, FormHelper } from "utils/helpers";

function InputSuggestionsFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, readonly } = props;

  const extraProps = field.extraProps as InputSuggestionsExtraProps<T>;
  const formikProps = useFormikContext<T>();

  const onChangeHandler = (selectedItem: SelectionItem) => {
    extraProps.referenceIdFieldName &&
      handleOnChangeCustom(
        FormHelper.formatReferenceFieldName(name, extraProps.referenceIdFieldName as string),
        selectedItem.id as number
      );

    extraProps.referenceFieldName &&
      handleOnChangeCustom(
        FormHelper.formatReferenceFieldName(name, extraProps.referenceFieldName as string),
        selectedItem.value
      );

    setTimeout(() => {
      extraProps.onItemSelect && extraProps.onItemSelect(selectedItem, name, formikProps);
    });
  };

  const onFormSubmit = (response: SelectionResponse) => {
    onChangeHandler({ id: response.id, value: response.value });
  };

  return !readonly ? (
    <InputSuggestions
      label={field.label && LocalizationHelperInstance.getFormattedMessage(field.label)}
      suggestions={value}
      form={extraProps.form}
      onFormSubmit={onFormSubmit}
      onChange={onChangeHandler}
      onAddButtonClick={extraProps.onAddButtonClick?.bind(null, formikProps)}
      autogeneratedText={extraProps.autogeneratedText}
    />
  ) : (
    <></>
  );
}

export default InputSuggestionsFormField;
